import { PasteRule } from '@tiptap/core';
import { MarkType } from '@tiptap/pm/model';

// Tiptap's built-in link paste rule runs against the document after markdownLinkPasteRule has replaced [label](url)
// with just label. When the label itself looks like a URL it re-links the label to itself, clobbering the pasted url.
export const skipAlreadyLinkedText = (
  rule: PasteRule,
  type: MarkType,
): PasteRule =>
  new PasteRule({
    find: rule.find,
    handler: (props) => {
      if (props.state.doc.rangeHasMark(props.range.from, props.range.to, type))
        return undefined;

      return rule.handler(props);
    },
  });
